import React from 'react';
import PropTypes from 'prop-types';

import TagTooltip from './tooltip';
import Tooltip from 'components/tooltip';

import './styles.scss';

export default function Tag({ tag }) {
  return (
    <Tooltip content={<TagTooltip tag={tag} />} overlayClassName="deal-tagged-body-tag-tooltip">
      <div aria-label={tag.label} className="deal-tagged-body-tag p-1 bg-dark-subtle rounded text-nowrap">
        {tag.label}
      </div>
    </Tooltip>
  );
}

Tag.propTypes = {
  tag: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
};
